import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { IAddPrimaryTelnyxNumberSearchParams } from "../models/telnyx/add-primary-telnyx-number-search-params";
import { ISendTelnyxFaxParams } from "../models/telnyx/send-telnyx-fax-params";
import { ITelnyxNumber } from "../models/telnyx/telnyx-number";
import { ITelnyxNumbersSearchParams } from "../models/telnyx/telnyx-numbers-search-params";

@Injectable({ providedIn: "root" })
export class TelnyxService {
  constructor(private readonly _httpClient: HttpClient) {}

  getNumbers(params: ITelnyxNumbersSearchParams) {
    return this._httpClient.get<ITelnyxNumber[]>(this.withBaseUrl("/numbers"), { params });
  }

  addPrimaryNumber(params: IAddPrimaryTelnyxNumberSearchParams) {
    return this._httpClient.post<void>(this.withBaseUrl("/Add-Primary-Number"), {}, { params });
  }

  sendFax(params: ISendTelnyxFaxParams, file: Blob, fileName: string = "file.pdf") {
    const formData = new FormData();

    formData.append("File", file, fileName);

    formData.append("ToNumber", params.toNumber);
    formData.append("FromNumber", params.fromNumber);
    formData.append("SendCopies", params.sendCopies);

    if (params.folderName) {
      formData.append("FolderName", params.folderName);
    }

    if (params.emails && params.emails.length > 0) {
      params.emails.forEach(email => {
        formData.append("Emails", email);
      });
    }

    return this._httpClient.post<void>(this.withBaseUrl("/Send-Fax"), formData);
  }

  private withBaseUrl(endpoint: string) {
    return `${environment.serverUrl}/telnyx${endpoint}`;
  }
}
